
import React, { useState, useEffect, useRef } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import CloseIcon from "@mui/icons-material/Close";
import Modal from "@mui/material/Modal";
import ProtocoloDetalles from "./protocoloDetalles";
import Moment from "moment";
import Box from "@mui/material/Box";
import {
  Typography, Paper,
  // Dialog, DialogTitle, DialogContent, DialogActions, Button,
  Backdrop,
  Tooltip,
  LinearProgress
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle";
import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import { GetProtocoloDetalle } from "../../logic/aplication/getProtocoloDetalle";
import { ProtocoloService } from "../../logic/domain/services/protocoloService";
import { ApiImplementation } from "../../logic/infraestructure/api/apiImplementation";
import { GetProtocolosInforme } from "../../logic/aplication/getProtocoloInforme";
import { GetHistoricos } from "../../logic/aplication/getHistoricos";
import { Protocolo } from "../../logic/domain/entities/protocolo";
import { ProtocoloDetalle } from "../../logic/domain/entities/ProtocoloDetalle";
import { PrestacionHistorico } from "../../logic/domain/entities/prestacionHistorico";
import {
  ArrowDownward, ArrowUpward//, Description

} from "@mui/icons-material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import FileDownloadOffIcon from '@mui/icons-material/FileDownloadOff';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import DialogModal from "./dialog";
import { saveHtmlToPdf } from "../utils/pdfUtils";

interface Filtro {
  startDate: string;
  endDate: string;
  cantidad: number;
  visto: string;
}

interface ResultTableProps {
  isSmallScreenResult: boolean;
  filtroResultTable: Filtro; // Usa el tipo Filtro aquí
  searchQuery: string;
  localStorageUpdateResultTable: boolean;
  onLogoutResultTable: () => void;
  onPrestacionClick: (protocolo: Protocolo) => void
}

const ResultTable: React.FC<ResultTableProps> = ({
  isSmallScreenResult,
  filtroResultTable,
  searchQuery,
  localStorageUpdateResultTable,
  onLogoutResultTable,
  onPrestacionClick
}) => {


  Moment.locale("es");
  const [protocolos, setProtocolos] = useState<Protocolo[]>([]);
  const [currentProtocolo, setCurrentProtocolo] = useState(0);
  const [pedido, setPedido] = useState<ProtocoloDetalle[]>([]);
  const [informe, setInforme] = useState("");
  const [showModalDetails, setShowModalDetails] = useState(false);
  const [showModalInfo, setShowModalInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const printRef = useRef<HTMLDivElement | null>(null);
  const [loadingInforme, setLoadingInforme] = useState(false);
  const [orderDirection, setOrderDirection] = useState({ field: "", direction: "asc" });
  const [pdfProgress, setPdfProgress] = useState({ current: 0, total: 0, message: '' });

  const apiImplementation = new ApiImplementation()
  const protocoloService = new ProtocoloService(apiImplementation)
  const getProtocoloDetalle = new GetProtocoloDetalle(protocoloService)
  const getProtocoloInforme = new GetProtocolosInforme(protocoloService)
  const getHistoricos = new GetHistoricos(protocoloService)


  useEffect(() => {
    const storedProtocolos = localStorage.getItem("protocolos");
    if (storedProtocolos) {
      const parsedProtocolos = JSON.parse(storedProtocolos);
      const protocolos: Protocolo[] = parsedProtocolos.map((protocoloData: any) =>
        new Protocolo(
          protocoloData.id_orden_trabajo,
          protocoloData.pedido,
          protocoloData.fecha_pedido,
          protocoloData.entrega_final,
          protocoloData.rotulo,
          protocoloData.visto,
          protocoloData.impreso,
          protocoloData.estado_resultados,
          protocoloData.estado_validacion,
          protocoloData.tiene_resultados_marcados_para_antecedentes,
          protocoloData.letra_origen,
          protocoloData.numero_pedido,
          protocoloData.impreso_fecha,
          protocoloData.visto_fecha,
          protocoloData.es_derivacion
        )
      );
      setProtocolos(protocolos);
    }
  }, [localStorageUpdateResultTable]);

  useEffect(() => {
    const storedProtocolos = localStorage.getItem("protocolos");
    let protocolosF: Protocolo[] = []
    if (storedProtocolos) {
      const parsedProtocolos = JSON.parse(storedProtocolos);
      protocolosF = Protocolo.fromCollection(parsedProtocolos)

    }

    let filteredData: Protocolo[] = protocolosF ? (protocolosF) : [];
    if (filteredData) {
      if (filtroResultTable.visto && filtroResultTable.visto !== "all") {
        filteredData = filteredData.filter(
          (protocolo: Protocolo) =>
            protocolo.getVisto() === (filtroResultTable.visto === "visto")
        );
      }

      if (searchQuery) {
        filteredData = filteredData.filter((protocolo: Protocolo) =>
          protocolo.getPedido().toLowerCase().includes(searchQuery.toLowerCase())
        );
      }

      filteredData = filteredData.slice(0, filtroResultTable.cantidad);

      setProtocolos(filteredData);
    }
  }, [filtroResultTable, searchQuery, localStorageUpdateResultTable]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token || currentProtocolo <= 0) return;

    setLoading(true);
    getProtocoloDetalle.execute(currentProtocolo, token)
      .then((response: ProtocoloDetalle[]) => setPedido(response))
      .catch((error) => {
        console.error(error.message);
        console.error(error);
        setErrorMessage('Sesión expirada');
        setErrorModalOpen(true);
      })
      .finally(() => setLoading(false));
  }, [currentProtocolo]);

  useEffect(() => {
   const token = localStorage.getItem("token");
    if (!token || currentProtocolo <= 0) return;

    setLoading(true);
    getProtocoloInforme.execute(currentProtocolo, token)
      .then((response: string) => setInforme(response))
      .catch((error) => {
        console.error(error.message);
        console.error(error);
        setErrorMessage('Sesión expirada');
        setErrorModalOpen(true);
      })
      .finally(() => { setLoading(false); });
  }, [showModalInfo]);

  // Función para manejar el ordenamiento
  const handleSort = (field: string) => {
    const isAsc = orderDirection.field === field && orderDirection.direction === "asc";
    setOrderDirection({ field, direction: isAsc ? "desc" : "asc" });

    const sortedData = [...protocolos].sort((a: Protocolo, b: Protocolo) => {
      if (field === "fechaPedido") {
        return isAsc
          ? new Date(b.getFechaPedido()).getTime() - new Date(a.getFechaPedido()).getTime()
          : new Date(a.getFechaPedido()).getTime() - new Date(b.getFechaPedido()).getTime();
      } else if (field === "entregaFinal") {
        return isAsc
          ? new Date(b.getEntregaFinal()).getTime() - new Date(a.getEntregaFinal()).getTime()
          : new Date(a.getEntregaFinal()).getTime() - new Date(b.getEntregaFinal()).getTime();
      }
      return 0;
    });

    setProtocolos(sortedData);
  };

  const showDetails = (protocolo: Protocolo) => {

    setShowModalDetails(true);
    setCurrentProtocolo(protocolo.getIdOrdenTrabajo());


  };

  // Función para cargar el informe
  const showInforme = async (protocolo: Protocolo) => {
    if (protocolo.getEstadoValidacion() === "PENDIENTE") return;

    setLoadingInforme(true); // Activa el Backdrop mientras se carga el informe
    setCurrentProtocolo(protocolo.getIdOrdenTrabajo());
    setLoadingInforme(false); // Desactiva el Backdrop
    setShowModalInfo(true); // Muestra el Modal solo cuando el informe está listo
  };


  // Nueva función para obtener el informe de la API y luego imprimirlo
  const requestAndPrintInforme = async (protocolo: Protocolo) => {
    if (protocolo.getEstadoValidacion() === "PENDIENTE") return;
    
    const ordenTrabajo = protocolo.getIdOrdenTrabajo();
    if (ordenTrabajo <= 0) {
      console.error('Orden de trabajo inválida:', ordenTrabajo);
      return;
    }
    
    setLoadingInforme(true); // Muestra el backdrop de carga
    setPdfProgress({ current: 0, total: 0, message: '' });
    
    try {
      const token = localStorage.getItem("token") as string;
      
      // Obtener el informe HTML
      const response = await getProtocoloInforme.execute(protocolo.getIdOrdenTrabajo(), token);
      setInforme(response);
      
      // Obtener históricos si el protocolo los tiene
      let historicos: PrestacionHistorico[] = [];
      if (protocolo.getTieneResultadosMarcadosParaAntecedentes()) {
        try {
          historicos = await getHistoricos.execute(protocolo.getIdOrdenTrabajo(), token);
        } catch (error) {
          console.warn('No se pudieron obtener los históricos:', error);
        }
      }
      
      // Generar PDF con históricos y callback de progreso
      await saveHtmlToPdf(
        response, 
        protocolo, 
        historicos,
        (current, total, message) => {
          setPdfProgress({ current, total, message });
        }
      );
    } catch (error) {
      console.error(error);
      setErrorMessage('Error al obtener el informe');
      setErrorModalOpen(true);
    } finally {
      setLoadingInforme(false); // Oculta el backdrop de carga
      setPdfProgress({ current: 0, total: 0, message: '' });
    }
  };



  return (

    <div>
      <Box sx={{ padding: 2 }}>
        {isSmallScreenResult ? (
          <Box>{
            protocolos.map((protocolo: Protocolo) => (
              <Box
                key={protocolo.getIdOrdenTrabajo()}
                sx={{
                  backgroundColor: "white",
                  padding: 2,
                  marginBottom: 2,
                  borderRadius: "8px",
                }}
              >
                <Typography variant="h6">Pedido: {protocolo.getPedido()}</Typography>
                <Typography>
                  Fecha: {Moment(protocolo.getFechaPedido()).format("DD-MM-YYYY")}
                </Typography>
                <Typography>
                  Entrega Final:{" "}
                  {Moment(protocolo.getEntregaFinal()).format("DD-MM-YYYY")}
                </Typography>
                <Typography>Estado: {protocolo.getEstadoValidacion()}</Typography>
                <Typography>Visto: {protocolo.getVisto() ? "Sí" : "No"}</Typography>
                <Typography>
                  Impreso: {protocolo.getImpreso() ? "Sí" : "No"}
                </Typography>
                <IconButton onClick={() => showDetails(protocolo)}>
                  <SummarizeOutlinedIcon />
                </IconButton>
                <IconButton onClick={() => showInforme(protocolo)}>
                  {(protocolo.getEstadoValidacion() === "PENDIENTE") ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
                <IconButton onClick={() => { requestAndPrintInforme(protocolo) }}>
                  {(protocolo.getEstadoValidacion() === "PENDIENTE") ? <FileDownloadOffIcon /> : <DownloadIcon />}
                </IconButton>
                <IconButton title="Ver antecedente" onClick={() => onPrestacionClick(protocolo)}>
                  {(protocolo.getTieneResultadosMarcadosParaAntecedentes() === false) ? null : <QueryStatsIcon />}
                </IconButton>
              </Box>
            ))}
          </Box>
        ) : (
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: "8px",
              overflowX: "auto",
              maxHeight: '500px', 
              boxShadow: '0px 2px 4px rgba(0,0,0,0.1)', 
              padding: '0',
            }}
          >
            <Table stickyHeader >
              <TableHead>
                <TableRow>
                  <TableCell>Pedido</TableCell>
                  <TableCell>
                    Fecha Pedido 
                    <IconButton onClick={() => handleSort("fechaPedido")} size="small">
                      {orderDirection.field === "fechaPedido" && orderDirection.direction === "asc" ? (
                        <ArrowUpward fontSize="small" />
                      ) : (
                        <ArrowDownward fontSize="small" />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    Fecha Entrega
                    <IconButton onClick={() => handleSort("entregaFinal")} size="small">
                      {orderDirection.field === "entregaFinal" && orderDirection.direction === "asc" ? (
                        <ArrowUpward fontSize="small" />
                      ) : (
                        <ArrowDownward fontSize="small" />
                      )}
                    </IconButton>
                  </TableCell>
                  <TableCell>Estado</TableCell>
                  <TableCell>Visto</TableCell>
                  <TableCell>Impreso</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {protocolos.map((protocolo: Protocolo) => (
                  <TableRow key={protocolo.getIdOrdenTrabajo()}>
                    <TableCell>{protocolo.getPedido()}</TableCell>
                    <TableCell>
                      {Moment(protocolo.getFechaPedido()).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell>
                      {Moment(protocolo.getEntregaFinal()).format("DD-MM-YYYY")}
                    </TableCell>
                    <TableCell>{protocolo.getEstadoValidacion()}</TableCell>
                    <TableCell>
                      {protocolo.getVisto() ? (
                        <CircleIcon fontSize="small" color="success" />
                      ) : (
                        <CircleIcon fontSize="small" color="disabled" />
                      )}
                    </TableCell>
                    <TableCell>
                      {protocolo.getImpreso() ? (
                        <CircleIcon fontSize="small" color="success" />
                      ) : (
                        <CircleIcon fontSize="small" color="disabled" />
                      )}
                    </TableCell>
                    <TableCell>
                      <Tooltip title="Ver detalles del pedido" arrow>
                        <IconButton onClick={() => showDetails(protocolo)}>
                          <SummarizeOutlinedIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver informe del protocolo" arrow>
                        <IconButton onClick={() => showInforme(protocolo)}>
                          {(protocolo.getEstadoValidacion() === "PENDIENTE") ? <VisibilityOffIcon /> : <VisibilityIcon />}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Descargar protocolo" arrow>
                        <IconButton onClick={() => { requestAndPrintInforme(protocolo) }}>
                          {(protocolo.getEstadoValidacion() === "PENDIENTE") ? <FileDownloadOffIcon /> : <DownloadIcon />}
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver antecedentes" arrow>
                        <span>
                          <IconButton onClick={() => onPrestacionClick(protocolo)} disabled={!protocolo.getTieneResultadosMarcadosParaAntecedentes()}>
                            {(protocolo.getTieneResultadosMarcadosParaAntecedentes() === false) ? null : <QueryStatsIcon />}
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Box>
        )}
      </Box>
      <Backdrop open={loadingInforme} sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 1 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
          <CircularProgress color="inherit" />
          {pdfProgress.message && (
            <Box sx={{ width: '300px', textAlign: 'center' }}>
              <Typography variant="body2" sx={{ mb: 1, color: 'white' }}>
                {pdfProgress.message}
              </Typography>
              {pdfProgress.total > 0 && (
                <LinearProgress 
                  variant="determinate" 
                  value={(pdfProgress.current / pdfProgress.total) * 100} 
                  sx={{ 
                    height: 8, 
                    borderRadius: 1,
                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                    '& .MuiLinearProgress-bar': {
                      backgroundColor: '#00A3A8'
                    }
                  }}
                />
              )}
            </Box>
          )}
        </Box>
      </Backdrop>
      <Modal
        open={showModalInfo}
        onClose={() => {
          setShowModalInfo(false);
          setInforme("");
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "auto",
        }}
      >
        <Paper
          sx={{
            backgroundColor: "white",
            borderRadius: "8px",
            padding: 2,
            width: "95%",
            maxWidth: "930px",
            maxHeight: "90vh",
            overflow: "auto",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <IconButton
              aria-label="close"
              onClick={() => setShowModalInfo(false)}
              sx={{ color: (theme) => theme.palette.grey[500] }}
            >
              <CloseIcon />
            </IconButton>
            <div style={{ flexGrow: 1, textAlign: "center" }}>
              {loadingInforme || informe === '{"data":"No encontrado"}' || informe === '' || typeof informe !== 'string' ? (
                <span>Cargando informe...</span>
              ) : null}
            </div>

          </Box>

          {!(loadingInforme || informe === '{"data":"No encontrado"}' || informe === '' || typeof informe !== 'string') && (
            <div ref={printRef} dangerouslySetInnerHTML={{ __html: informe }}></div>
          )}
        </Paper>
      </Modal>

      <Modal open={showModalDetails} onClose={() => setShowModalDetails(false)}>
        <Paper
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
            maxHeight: "90vh",
          }}
        >
          <IconButton
            title="Cerrar"
            aria-label="close"
            onClick={() => setShowModalDetails(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          {loading && <CircularProgress />}
          <ProtocoloDetalles pedido={pedido} sx={{ fontSize: "0.9rem" }} />
        </Paper>
      </Modal>
      <DialogModal onLogoutFromMenu={onLogoutResultTable} errorMessage={errorMessage} open={errorModalOpen} />
    </div>

  );
};

export default ResultTable;

